import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $RadioCardInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  background: transparent;
`;

export const $ImageHoveredContainer = styled.div`
  display: none;
  align-items: flex-start;
  justify-content: center;
  transition-duration: ${({ theme }) => theme.interactions.basicTiming};

  svg {
    @media ${media.minWidth.sm} {
      width: ${spacing('xxl')};
    }
    width: ${spacing('xl')};
    height: auto;
  }
`;

export const $ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  transition-duration: ${({ theme }) => theme.interactions.basicTiming};

  svg {
    @media ${media.minWidth.sm} {
      width: ${spacing('xxl')};
    }
    width: ${spacing('xl')};
    height: auto;
  }
`;

interface RadioCardBodyProps {
  hasImage: boolean;
}

export const $RadioCardBody = styled.div<RadioCardBodyProps>`
  flex: 1;
  padding-left: unset;
  @media ${media.minWidth.sm} {
    padding-left: ${({ hasImage }) => (hasImage ? spacing('xl') : 'unset')};
    margin-top: unset;
  }

  ${fontStyle('base')};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  overflow: hidden;
`;

export const $RadioCardContainer = styled.div`
  display: flex;
  flex-direction: column;

  background: ${({ theme }) => theme.colors.white};

  cursor: pointer;
  transition-duration: ${({ theme }) => theme.interactions.basicTiming};

  flex: 1;
`;

export const $RadioCardFirstLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;

  @media ${media.minWidth.sm} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  flex: 1;
`;

export const $ItemTitle = styled.div<{ $isSelected: boolean }>`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  display: flex;
  align-items: center;
  color: ${({ theme, $isSelected }) => {
    if ($isSelected) {
      return theme.colors.primary;
    }

    return theme.newUI.defaultColors.menu;
  }};
  text-align: left;
`;

export const $RadioCardLabelContainer = styled.button<{
  disabled?: boolean;
  $isSelected: boolean;
}>`
  background-color: transparent;

  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  transition-duration: ${({ theme }) => theme.interactions.basicTiming};

  border-width: ${spacing('px')};
  border-style: solid;
  border-color: ${({ theme, $isSelected }) => {
    if ($isSelected) {
      return theme.colors.primary;
    }

    return theme.colors.default;
  }};
  border-radius: ${({ theme }) => theme.tw.radius.sm};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};

    ${$RadioCardInfo} *, ${$ItemTitle} * {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  @media ${media.minWidth.sm} {
    padding: ${spacing('xl')};
  }
  padding: ${spacing('md')};
`;

export const $RadioCardSubLine = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.disabled};
  margin-top: ${spacing(3.5)};
  padding-top: ${spacing(3.5)};
`;

export const $ItemContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${media.minWidth.sm} {
    flex-direction: row;
    align-items: center;
  }
  align-items: start;
  justify-content: space-between;
  gap: ${spacing('xs')};
`;

export const $ItemHighlighting = styled.div`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  margin: ${spacing('xs')} 0;
  &&&& {
    color: ${({ theme }) => theme.colors.success} !important;
  }
`;

export const $ItemHighlightingIcon = styled.span`
  margin-right: ${spacing('sm')};
  display: flex;
`;

export const $ItemDescription = styled.div`
  width: 100%;
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  margin: ${spacing('xs')} 0;
  white-space: pre-wrap;
  text-align: left;
`;

export const $ItemPrice = styled.div<{
  $hasPrice: boolean;
  $hasPickupPointType: boolean;
}>`
  text-align: left;
  display: flex;
  gap: ${spacing('xs')};

  ${({ $hasPrice, theme }) =>
    $hasPrice
      ? `
        font-weight: ${fontWeight('semibold')};
        font-size: ${({
          $hasPickupPointType,
        }: {
          $hasPickupPointType: boolean;
        }) => ($hasPickupPointType ? '14px' : '16px')};
        line-height: 16px;
        color: ${theme.colors.primary};
        @media ${media.maxWidth.sm} {
          margin-top: unset;
          font-weight: ${fontWeight('medium')};
        }
      `
      : `
        color: ${theme.colors.paragraphTextColor};
        @media ${media.maxWidth.sm} {
          color: ${theme.colors.black};
          margin-top: ${spacing(3.5)};
          font-weight: ${fontWeight('medium')};
        }
      `}
`;

export const $ItemContentTextWrapper = styled.div`
  width: 80%;
  @media ${media.maxWidth.sm} {
    width: 100%;
  }
`;

export const $ItemLogo = styled.div`
  width: 60px;
  display: flex;
  justify-content: center;

  & img {
    max-height: ${spacing(9)};
    max-width: 100%;
  }
`;
export const $ItemDistance = styled.div`
  font-weight: 700;
  ${fontStyle('sm')};
  margin: ${spacing('xs')} 0;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
`;
